 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		10: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		10: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"157598a1c56b0952da9e46b7d136284b67fdd4e0","1":"afa251af0b7861470b3756f38989ef6e58aa85f9","2":"73edb1c957c2be104b0efcd8bed34389291829fa","3":"997534f75bec0c8e7259c166b5b43741bde55aed","4":"a3642c8796a25763c8ca87d90f171d41ec82a6e5","5":"styles","6":"11dd2a487fbd0b2bc4903be47570e75ed3b372ab","7":"325e8fbac9e8e621cac8d1682aa7a88b146c49f1","8":"7e11d01915df03acf30594788cddfc08093c0872","9":"c4d3fb329017685d71f8032ca80be4c033aa1470","13":"component---toggl-src-articles-index-js","14":"component---toggl-src-case-studies-index-js","15":"component---toggl-src-downloadables-index-js","16":"component---toggl-src-ebooks-index-js","17":"component---toggl-src-integration-index-js","18":"component---toggl-src-invitation-index-js","19":"component---toggl-src-job-index-js","20":"component---toggl-src-legal-index-js","21":"component---toggl-src-pages-404-js","22":"component---toggl-src-pages-fun-and-games-index-js","23":"component---toggl-src-pages-index-index-js","24":"component---toggl-src-pages-jobs-index-js","25":"component---toggl-src-pages-legal-index-js","26":"component---toggl-src-pages-mission-index-js","27":"component---toggl-src-pages-track-adobe-time-tracking-index-js","28":"component---toggl-src-pages-track-anti-surveillance-statement-index-js","29":"component---toggl-src-pages-track-business-resources-index-js","30":"component---toggl-src-pages-track-completed-signup-js","31":"component---toggl-src-pages-track-contact-js","32":"component---toggl-src-pages-track-culture-index-js","33":"component---toggl-src-pages-track-customers-index-js","34":"component---toggl-src-pages-track-demo-request-confirmation-js","35":"component---toggl-src-pages-track-demo-request-index-js","36":"component---toggl-src-pages-track-device-unsupported-js","37":"component---toggl-src-pages-track-features-index-js","38":"component---toggl-src-pages-track-forgot-password-js","39":"component---toggl-src-pages-track-freelance-time-tracking-index-js","40":"component---toggl-src-pages-track-index-index-js","41":"component---toggl-src-pages-track-integrations-index-js","42":"component---toggl-src-pages-track-kronos-alternative-index-js","43":"component---toggl-src-pages-track-legal-index-js","44":"component---toggl-src-pages-track-login-js","45":"component---toggl-src-pages-track-pricing-index-js","46":"component---toggl-src-pages-track-product-demo-index-js","47":"component---toggl-src-pages-track-productivity-resources-index-js","48":"component---toggl-src-pages-track-sso-link-account-js","49":"component---toggl-src-pages-track-sso-login-js","50":"component---toggl-src-pages-track-sso-must-link-js","51":"component---toggl-src-pages-track-time-management-index-js","52":"component---toggl-src-pages-track-time-tracking-large-teams-index-js","53":"component---toggl-src-pages-track-time-tracking-small-teams-index-js","54":"component---toggl-src-pages-track-toggl-button-feedback-js","55":"component---toggl-src-pages-track-toggl-button-login-js","56":"component---toggl-src-pages-track-unsubscribe-disable-product-emails-code-js","57":"component---toggl-src-pages-track-unsubscribe-disable-weekly-report-code-js","58":"component---toggl-src-paid-ad-landing-pages-index-js","59":"component---toggl-src-personas-index-js","60":"component---toggl-src-product-index-js","61":"component---toggl-src-signup-index-js","62":"component---toggl-src-spokes-index-js","63":"component---toggl-src-templates-track-reset-password-js","64":"component---toggl-src-timer-index-js","65":"component---toggl-src-use-case-index-js","66":"component---toggl-src-webinars-index-js"}[chunkId]||chunkId) + "-" + {"0":"c043bb42b95cfc535d52","1":"2886348dbafde52a4605","2":"9cdde7560010ec3cb608","3":"b8fa431436dcba8930a5","4":"644d6127e839f8956c4b","5":"29163f9dced6fe4a408a","6":"e539b0220196983918eb","7":"635eebfc738e7e904ba2","8":"ddbb7bf3611962ef0153","9":"82c3e6dde1d2db030cc9","11":"618e9d4446cbd625eb5c","13":"8966b009bb384fc7ec10","14":"7bd33d32a415d6a8ac7f","15":"72cbc1c54cbff891471c","16":"24f6df678c62006f9f6a","17":"de8dbee650501ecb07c9","18":"e8639529aee2f4b2a0f5","19":"11e4e17c8f9c5bfe29c6","20":"217f72deeb22e7184542","21":"c516fec6a3c0353c140f","22":"c5405f71b697a21e3ab8","23":"ae53f45c31803396c694","24":"433f4be7484e5e590184","25":"cf81bd807e6495a49b9a","26":"a7852f3656f9e65e77e7","27":"3c89e5b71d209aa2118e","28":"dca547922f9c740b122b","29":"1d2f9f163fe3a8a7fd1f","30":"61da852075d303ba0f0b","31":"5935548e39b1d5fb01e9","32":"64f89f9e9bea4ea9012a","33":"98db7d08e313b48314da","34":"c8c47be57233d99f8d07","35":"b69d9bff1bf42f382384","36":"c48902f8ec540720493f","37":"c7c6278024ffc84f0d5c","38":"5943dae57856447d7cea","39":"abd1f641cad908b00a96","40":"729ce092e74490d69d1c","41":"4e83885d9c8c4a3590d2","42":"3cda136c18e202428c92","43":"85de7553ff96cb7219f1","44":"b3dd0077a6a6737dda62","45":"75b8c964437dab5b04be","46":"d90eac3122656b9bb2eb","47":"8b4bc28f3605ac57af68","48":"19736803e15aa24d734c","49":"1561d1a8481e926b01ad","50":"6f971844a6f0cbb584e2","51":"1fa617cd593b6c063c75","52":"22f60b21da0fae4c1e20","53":"140437231ffce5556c99","54":"e2af58160c71d5c20a27","55":"a74b7a7760176cd8685b","56":"6545a6e723ae17aa4118","57":"a89df3dfaedfa9a1f463","58":"35cf422e3eb2a6b18c8c","59":"87f4565d7ee1b76ed0f3","60":"ee9a9bec9e6f223dc7a5","61":"477565d5c18b692c3602","62":"f1d35f2754bbe02e5157","63":"11b00f1441645109c45e","64":"f70b3551376bf6c019bc","65":"1d9d7afb4622ba94e34c","66":"25b7216ee9877351e2bb","69":"54e3ddf7bdbcaa68f8a1","70":"059a14a293396aa97388"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"5":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"157598a1c56b0952da9e46b7d136284b67fdd4e0","1":"afa251af0b7861470b3756f38989ef6e58aa85f9","2":"73edb1c957c2be104b0efcd8bed34389291829fa","3":"997534f75bec0c8e7259c166b5b43741bde55aed","4":"a3642c8796a25763c8ca87d90f171d41ec82a6e5","5":"styles","6":"11dd2a487fbd0b2bc4903be47570e75ed3b372ab","7":"325e8fbac9e8e621cac8d1682aa7a88b146c49f1","8":"7e11d01915df03acf30594788cddfc08093c0872","9":"c4d3fb329017685d71f8032ca80be4c033aa1470","13":"component---toggl-src-articles-index-js","14":"component---toggl-src-case-studies-index-js","15":"component---toggl-src-downloadables-index-js","16":"component---toggl-src-ebooks-index-js","17":"component---toggl-src-integration-index-js","18":"component---toggl-src-invitation-index-js","19":"component---toggl-src-job-index-js","20":"component---toggl-src-legal-index-js","21":"component---toggl-src-pages-404-js","22":"component---toggl-src-pages-fun-and-games-index-js","23":"component---toggl-src-pages-index-index-js","24":"component---toggl-src-pages-jobs-index-js","25":"component---toggl-src-pages-legal-index-js","26":"component---toggl-src-pages-mission-index-js","27":"component---toggl-src-pages-track-adobe-time-tracking-index-js","28":"component---toggl-src-pages-track-anti-surveillance-statement-index-js","29":"component---toggl-src-pages-track-business-resources-index-js","30":"component---toggl-src-pages-track-completed-signup-js","31":"component---toggl-src-pages-track-contact-js","32":"component---toggl-src-pages-track-culture-index-js","33":"component---toggl-src-pages-track-customers-index-js","34":"component---toggl-src-pages-track-demo-request-confirmation-js","35":"component---toggl-src-pages-track-demo-request-index-js","36":"component---toggl-src-pages-track-device-unsupported-js","37":"component---toggl-src-pages-track-features-index-js","38":"component---toggl-src-pages-track-forgot-password-js","39":"component---toggl-src-pages-track-freelance-time-tracking-index-js","40":"component---toggl-src-pages-track-index-index-js","41":"component---toggl-src-pages-track-integrations-index-js","42":"component---toggl-src-pages-track-kronos-alternative-index-js","43":"component---toggl-src-pages-track-legal-index-js","44":"component---toggl-src-pages-track-login-js","45":"component---toggl-src-pages-track-pricing-index-js","46":"component---toggl-src-pages-track-product-demo-index-js","47":"component---toggl-src-pages-track-productivity-resources-index-js","48":"component---toggl-src-pages-track-sso-link-account-js","49":"component---toggl-src-pages-track-sso-login-js","50":"component---toggl-src-pages-track-sso-must-link-js","51":"component---toggl-src-pages-track-time-management-index-js","52":"component---toggl-src-pages-track-time-tracking-large-teams-index-js","53":"component---toggl-src-pages-track-time-tracking-small-teams-index-js","54":"component---toggl-src-pages-track-toggl-button-feedback-js","55":"component---toggl-src-pages-track-toggl-button-login-js","56":"component---toggl-src-pages-track-unsubscribe-disable-product-emails-code-js","57":"component---toggl-src-pages-track-unsubscribe-disable-weekly-report-code-js","58":"component---toggl-src-paid-ad-landing-pages-index-js","59":"component---toggl-src-personas-index-js","60":"component---toggl-src-product-index-js","61":"component---toggl-src-signup-index-js","62":"component---toggl-src-spokes-index-js","63":"component---toggl-src-templates-track-reset-password-js","64":"component---toggl-src-timer-index-js","65":"component---toggl-src-use-case-index-js","66":"component---toggl-src-webinars-index-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"f56c0cc9ef93d9e0458f","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://public-assets.toggl.com/b/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
